/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Event_Gap_TooltipInputs */

const en_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The minimum and maximum duration in frames between events`)
};

const fr_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree minimale et maximale en frames entre les evenements`)
};

const de_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die minimale und maximale Dauer in Frames zwischen Ereignissen`)
};

const it_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durata minima e massima in fotogrammi tra gli eventi`)
};

const ru_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная и максимальная продолжительность в кадрах между событиями.`)
};

const es_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La duración mínima y máxima en cuadros entre eventos`)
};

const zh_cn2_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件之间以帧为单位的最小和最大持续时间`)
};

const ja_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント間のフレームの最小および最大期間`)
};

const hi_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं के बीच फ्रेम में न्यूनतम और अधिकतम अवधि`)
};

const pt_pt2_style_guide_manager_event_gap_tooltip = /** @type {(inputs: Style_Guide_Manager_Event_Gap_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duração mínima e máxima em frames entre eventos`)
};

/**
* | output |
* | --- |
* | "The minimum and maximum duration in frames between events" |
*
* @param {Style_Guide_Manager_Event_Gap_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_event_gap_tooltip = /** @type {((inputs?: Style_Guide_Manager_Event_Gap_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Event_Gap_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_event_gap_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_event_gap_tooltip(inputs)
	return en_style_guide_manager_event_gap_tooltip(inputs)
});